import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CapacityPlanRoutesQueryVariables = Types.Exact<{
  runId: Types.Scalars['ID'];
  depotIndex: Types.Scalars['Int'];
}>;


export type CapacityPlanRoutesQuery = { __typename?: 'Query', capacityPlanRoutes: { __typename?: 'CapacityPlanDepotRoutes', depotIndex: number, solves: Array<{ __typename?: 'CapacityPlanSolve', id: any, clusterIndex: number, status: Types.CapacityPlanSolveStatus, error?: string | null, driverCount?: number | null, routes: Array<{ __typename?: 'CapacityPlanRoute', vehicleId: number, durationSeconds: number, distanceMeters: number, serviceSeconds: number, deliveryCount: number, recipients: number, stopCount: number, endTime?: string | null, geometry: Array<Array<number>>, steps: Array<{ __typename?: 'CapacityPlanRouteStep', type: string, stopId?: number | null, deliveryIds: Array<any>, deliveryCodes: Array<string>, latitude?: number | null, longitude?: number | null, arrivalSeconds: number, serviceSeconds: number, load: number }> }>, unassigned: Array<{ __typename?: 'CapacityPlanUnassignedStop', stopId: number, deliveryIds: Array<any>, deliveryCodes: Array<string>, latitude: number, longitude: number, reason: string }> }> } };


export const CapacityPlanRoutesDocument = gql`
    query CapacityPlanRoutes($runId: ID!, $depotIndex: Int!) {
  capacityPlanRoutes(runId: $runId, depotIndex: $depotIndex) {
    depotIndex
    solves {
      id
      clusterIndex
      status
      error
      driverCount
      routes {
        vehicleId
        durationSeconds
        distanceMeters
        serviceSeconds
        deliveryCount
        recipients
        stopCount
        endTime
        geometry
        steps {
          type
          stopId
          deliveryIds
          deliveryCodes
          latitude
          longitude
          arrivalSeconds
          serviceSeconds
          load
        }
      }
      unassigned {
        stopId
        deliveryIds
        deliveryCodes
        latitude
        longitude
        reason
      }
    }
  }
}
    `;

/**
 * __useCapacityPlanRoutesQuery__
 *
 * To run a query within a React component, call `useCapacityPlanRoutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCapacityPlanRoutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCapacityPlanRoutesQuery({
 *   variables: {
 *      runId: // value for 'runId'
 *      depotIndex: // value for 'depotIndex'
 *   },
 * });
 */
export function useCapacityPlanRoutesQuery(baseOptions: Apollo.QueryHookOptions<CapacityPlanRoutesQuery, CapacityPlanRoutesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CapacityPlanRoutesQuery, CapacityPlanRoutesQueryVariables>(CapacityPlanRoutesDocument, options);
      }
export function useCapacityPlanRoutesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CapacityPlanRoutesQuery, CapacityPlanRoutesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CapacityPlanRoutesQuery, CapacityPlanRoutesQueryVariables>(CapacityPlanRoutesDocument, options);
        }
export type CapacityPlanRoutesQueryHookResult = ReturnType<typeof useCapacityPlanRoutesQuery>;
export type CapacityPlanRoutesLazyQueryHookResult = ReturnType<typeof useCapacityPlanRoutesLazyQuery>;
export type CapacityPlanRoutesQueryResult = Apollo.QueryResult<CapacityPlanRoutesQuery, CapacityPlanRoutesQueryVariables>;